var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 6.667,
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 6.667,
    y: 6.667,
    fill: "#DD0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 6.667,
    y: 13.333,
    fill: "#FFCE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.3a0c2aa693282017233c23c49e7b9d91.svg";
export { ForwardRef as ReactComponent };